"use client";
import { useAPI } from "@travel/shared/data-access";
import { getHotelAvailabilityURL } from "../hotel-api/hotel-api";
export function useHotelAvailabilityURL(request) {
    return useAPI(request, getHotelAvailabilityURL, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
}
